type TRegionKey =
  | 'midwest'
  | 'louisiana'
  | 'louisville'
  | 'carolinas'
  | 'nashville'
  | 'charlottesville';

const regionMap: Record<TRegionKey, string> = {
  midwest: 'https://78fb0754.flowpaper.com/MWJune2025/',
  louisiana: 'https://78fb0754.flowpaper.com/LouisianaIFMay2025Flowpaper/',
  louisville: 'https://78fb0754.flowpaper.com/LouisvilleIFMay2025Flowpaper/',
  carolinas: 'https://78fb0754.flowpaper.com/CarolinaMay2025Flowpaper/',
  nashville: 'https://78fb0754.flowpaper.com/525NashvilleFeatures/',
  charlottesville: 'https://78fb0754.flowpaper.com/525CharlottesvilleIF/',
};

const idToRegion: Record<number, TRegionKey> = {
  21: 'louisiana', // lafayette
  20: 'louisiana', // baton rouge/new orleans
  44: 'louisville', // louisville
  18: 'carolinas', // asheville
  13: 'carolinas', // charleston
  10: 'carolinas', // charlotte
  15: 'carolinas', // columbia
  11: 'carolinas', // greensboro-winston
  14: 'carolinas', // greenville-spartanburg
  9: 'carolinas', // raleigh-durham
  12: 'carolinas', // wilmington
  45: 'carolinas', // franklin
  49: 'carolinas', // knoxville
  46: 'carolinas', // hilton head-savannah
  54: 'nashville', // Nashville/Lebanon/TN
  55: 'charlottesville', // Charlottesville/VA
};

export function getRegionUrlById(
  locationId: number | null | undefined,
): string {
  if (locationId == null || !(locationId in idToRegion)) {
    return regionMap['midwest'];
  }

  const regionKey = idToRegion[locationId];
  return regionMap[regionKey];
}
